import React from 'react';
import { Helmet } from 'react-helmet';

function General_FAQ_Seo() {
    return (
        <div>
            <Helmet>
                <title>Ifepay FAQs – Your Questions Answered</title>
                <meta name="description" content="Have questions about sending money to Nigeria with Ifepay? Find answers about security, transfer times, fees, and more. Get expert support for a seamless experience." />
                <meta property="og:title" content="Ifepay FAQs – Your Questions Answered" />
                <meta property="og:description" content="Have questions about sending money to Nigeria with Ifepay? Find answers about security, transfer times, fees, and more. Get expert support for a seamless experience." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/frequently-asked-questions"/>
            </Helmet>
        </div>
    )
}

export default General_FAQ_Seo
